import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { useCallback } from "react";

import { useUserStore } from "./useUserStore";

export const useSetUser = () => {
  const { setUser } = useUserStore();

  return useCallback(
    (user: IUser | undefined) => {
      setUser(user);
    },
    [setUser]
  );
};

export const useFetchUser = () => {
  const { fetchUser } = useUserStore();

  return useCallback(async () => {
    await fetchUser();
  }, [fetchUser]);
};
